<div
  id="side-nav"
  class="d-flex flex-column"
  [class.collapsed]="sideNavService.navCollapsed | async"
  *ngIf="authService.isAuthenticatedAndAgreed()"
>
  <nav class="d-flex flex-grow-1">
    <button
      *ngIf="!secondaryNav?.length"
      id="collapse-nav-toggle"
      type="button"
      class="btn btn-primary btn-sm rounded-circle"
      [ngbTooltip]="((sideNavService.navCollapsed | async) ? 'Expand' : 'Collapse') + ' nav'"
      placement="right"
      (click)="sideNavService.toggleNavCollapsed()"
    >
      <i
        [ngClass]="{
          fas: true,
          'fa-fw': true,
          'fa-chevron-right': (sideNavService.navCollapsed | async),
          'fa-chevron-left': (sideNavService.navCollapsed | async) === false
        }"
      ></i>
    </button>
    <ul
      class="list-unstyled primary-nav"
      [class.collapsed]="(sideNavService.navCollapsed | async) || showSecondaryNav"
      (mouseenter)="onPrimaryNavMouseEnter()"
      (mouseleave)="onPrimaryNavMouseLeave()"
    >
      <li>
        <a
          routerLink="{{ authService.roleDashboardUrl }}"
          routerLinkActive="active"
          [title]="linkTitles.myDashboard"
          [ngbTooltip]="linkTitles.myDashboard"
          [disableTooltip]="(sideNavService.navCollapsed | async) === false"
          placement="right"
          ><i class="fas fa-tachometer-alt"></i><span>{{ linkTitles.myDashboard }}</span></a
        >
      </li>

      <ng-container *ngIf="authService.isEntitled('/worklist/getWorklistJsonDetails.html')">
        <li>
          <a
            routerLink="/private/my-worklist"
            routerLinkActive="active"
            [title]="linkTitles.myWorklists"
            [ngbTooltip]="linkTitles.myWorklists"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-tasks"></i><span>{{ linkTitles.myWorklists }}</span></a
          >
        </li>
      </ng-container>

      <ng-container
        *ngIf="
          authService.isEntitled('/patients/searchAssociatedPatients.html') &&
          !authService.isEntitled('/patients/hideAssociatedPatients.html')
        "
      >
        <li>
          <a
            routerLink="/private/associated-patients"
            routerLinkActive="active"
            [title]="linkTitles.associatedPatients"
            [ngbTooltip]="linkTitles.associatedPatients"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-search-plus"></i><span>{{ linkTitles.associatedPatients }}</span></a
          >
        </li>
      </ng-container>

      <ng-container
        *ngIf="
          authService.isEntitled('/dashboard/diseaseManagement.html') &&
          (!authService.isUserRoleExternalAgency || authService.user.sudSmiProgramDashboardAccess)
        "
      >
        <li>
          <a
            routerLink="/private/programs-dashboard"
            routerLinkActive="active"
            [title]="linkTitles.dmDashboard"
            [ngbTooltip]="linkTitles.dmDashboard"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="far fa-list-alt"></i><span>{{ linkTitles.dmDashboard }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/patients/viewPatients.html')">
        <li>
          <a
            routerLink="/private/patient-search"
            routerLinkActive="active"
            [title]="linkTitles.searchMembers"
            [ngbTooltip]="linkTitles.searchMembers"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-search"></i><span>{{ linkTitles.searchMembers }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/patients/displayBulkAssignPatient.html')">
        <li>
          <a
            routerLink="/private/patient-bulk-assign"
            routerLinkActive="active"
            [title]="linkTitles.bulkAssignMembers"
            [ngbTooltip]="linkTitles.bulkAssignMembers"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-search"></i><span>{{ linkTitles.bulkAssignMembers }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/patients/saveManualPatientEntry.html')">
        <li>
          <a
            routerLink="/private/add-edit-manual-patient-entry"
            routerLinkActive="active"
            [title]="linkTitles.manualPatientEntry"
            [ngbTooltip]="linkTitles.manualPatientEntry"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-user-plus"></i><span>{{ linkTitles.manualPatientEntry }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/users/viewIndividualUsers.html')">
        <li>
          <a
            routerLink="/private/users/search"
            routerLinkActive="active"
            [title]="linkTitles.users"
            [ngbTooltip]="linkTitles.users"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-users"></i><span>{{ linkTitles.users }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/sftp/medical-homes/permissioned.html')">
        <li>
          <a
            routerLink="/private/report-files"
            routerLinkActive="active"
            [title]="linkTitles.reports"
            [ngbTooltip]="linkTitles.reports"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-file-export"></i><span>{{ linkTitles.reports }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/resource/getResourceSummary.html')">
        <li>
          <a
            routerLink="/private/resources"
            routerLinkActive="active"
            [title]="linkTitles.resources"
            [ngbTooltip]="linkTitles.resources"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-book"></i><span>{{ linkTitles.resources }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/resource/saveResource.html')">
        <li>
          <a
            routerLink="/private/manage-resources"
            routerLinkActive="active"
            [title]="linkTitles.manageResources"
            [ngbTooltip]="linkTitles.manageResources"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-pen-alt"></i><span>{{ linkTitles.manageResources }}</span></a
          >
        </li>
      </ng-container>

      <li class="border-bottom"></li>

      <ng-container *ngIf="authService.isEntitled('/assessment/displaymaintainassessments.html')">
        <ng-container *ngIf="authService.isEntitled('/assessment/displaymaintainassessments.html')">
          <li>
            <a
              routerLink="/private/assessments/maintain"
              routerLinkActive="active"
              [title]="linkTitles.maintainAssessments"
              [ngbTooltip]="linkTitles.maintainAssessments"
              [disableTooltip]="(sideNavService.navCollapsed | async) === false"
              placement="right"
              ><i class="fas fa-edit"></i><span>{{ linkTitles.maintainAssessments }}</span></a
            >
          </li>
        </ng-container>
        <li class="border-bottom"></li>
      </ng-container>

      <ng-container
        *ngIf="
          authService.isEntitled('/systemNotifications/fetchAll') &&
          authService.isEntitled('/systemNotifications/saveNotification') &&
          authService.isEntitled('/systemNotifications/editNotification') &&
          authService.isEntitled('/systemNotifications/deleteNotification') &&
          authService.isEntitled('/systemNotifications/saveFollowUp') &&
          authService.isEntitled('/systemNotifications/editFollowUp') &&
          authService.isEntitled('/systemNotifications/deleteFollowUp') &&
          authService.isEntitled('/notificationTemplate/fetchTemplates') &&
          authService.isEntitled('/notificationTemplate/saveTemplate') &&
          authService.isEntitled('/notificationTemplate/editTemplate') &&
          authService.isEntitled('/notificationTemplate/deleteTemplate')
        "
      >
        <li>
          <a
            routerLink="/private/app-notifications"
            routerLinkActive="active"
            [title]="linkTitles.configureAppNotifications"
            [ngbTooltip]="linkTitles.configureAppNotifications"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-bullhorn"></i><span>{{ linkTitles.configureAppNotifications }}</span></a
          >
        </li>

        <li class="border-bottom"></li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/worklist/fetchAllWorklists.html')">
        <li>
          <a
            routerLink="/private/add-edit-worklist"
            routerLinkActive="active"
            [title]="linkTitles.maintainWorklists"
            [ngbTooltip]="linkTitles.maintainWorklists"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-tasks"></i><span>{{ linkTitles.maintainWorklists }}</span></a
          >
        </li>
        <li class="border-bottom"></li>
      </ng-container>

      <ng-container *ngIf="externalNavItems?.length">
        <li *ngFor="let externalNavItem of externalNavItems">
          <a
            [href]="externalNavItem.url"
            target="_blank"
            [title]="externalNavItem.text"
            [ngbTooltip]="externalNavItem.text"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-external-link-alt"></i><span>{{ externalNavItem.text }}</span></a
          >
        </li>
        <li class="border-bottom"></li>
      </ng-container>
      <li>
        <a
          routerLink="/private/notifications"
          routerLinkActive="active"
          [title]="linkTitles.notifications"
          [ngbTooltip]="linkTitles.notifications"
          [disableTooltip]="(sideNavService.navCollapsed | async) === false"
          placement="right"
          ><i class="fas fa-bullhorn"></i><span>{{ linkTitles.notifications }}</span>
          <th-unread-notification-count
            [hideText]="showSecondaryNav || (sideNavService.navCollapsed | async)"
          ></th-unread-notification-count>
        </a>
      </li>
      <ng-container
        *ngIf="
          authService.isEntitled('/patients/fetchuserSentMessages.html') &&
          authService.isEntitled('/patients/fetchuserReceiveMessages.html')
        "
      >
        <li>
          <a
            routerLink="/private/messages"
            routerLinkActive="active"
            [title]="linkTitles.messenger"
            [ngbTooltip]="linkTitles.messenger"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
          >
            <i class="far fa-comment"></i><span>{{ linkTitles.messenger }}</span>
            <th-unread-message-count
              [hideText]="showSecondaryNav || (sideNavService.navCollapsed | async)"
            ></th-unread-message-count>
          </a>
        </li>
      </ng-container>

      <li>
        <a
          routerLink="/private/support-ticket"
          routerLinkActive="active"
          [title]="linkTitles.support"
          [ngbTooltip]="linkTitles.support"
          [disableTooltip]="(sideNavService.navCollapsed | async) === false"
          placement="right"
          ><i class="far fa-question-circle"></i><span>{{ linkTitles.support }}</span></a
        >
      </li>

      <ng-container *ngIf="authService.isEntitled('/new-user-request/upsert') && authService?.user?.asmStatus">
        <li>
          <a
            routerLink="/private/request-new-mhnconnect-user"
            routerLinkActive="active"
            [title]="linkTitles.requestNewMHNConnectUser"
            [ngbTooltip]="linkTitles.requestNewMHNConnectUser"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-user-plus"></i><span>{{ linkTitles.requestNewMHNConnectUser }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/users/updateMyUserProfile.html')">
        <li>
          <a
            [title]="linkTitles.updateProfile"
            (click)="openModal(editProfile)"
            [ngbTooltip]="linkTitles.updateProfile"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            href="javascript:"
            ><i class="fas fa-user-edit"></i><span>{{ linkTitles.updateProfile }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/feedback/addFeedback.html')">
        <li>
          <a
            [title]="linkTitles.userFeedback"
            (click)="openModal(userFeedback)"
            [ngbTooltip]="linkTitles.userFeedback"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            href="javascript:"
            ><i class="fas fa-comment-alt"></i><span>{{ linkTitles.userFeedback }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/members/duplicateMemberData.html')">
        <li>
          <a
            routerLink="/private/duplicate-members"
            routerLinkActive="active"
            [title]="linkTitles.duplicateMembers"
            [ngbTooltip]="linkTitles.duplicateMembers"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fa fa-address-card"></i><span>{{ linkTitles.duplicateMembers }}</span></a
          >
        </li>
      </ng-container>

      <ng-container *ngIf="authService.isEntitled('/users/viewSystemTest.html')">
        <li>
          <a
            routerLink="/private/system-test"
            routerLinkActive="active"
            [title]="linkTitles.systemTest"
            [ngbTooltip]="linkTitles.systemTest"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><i class="fas fa-check"></i><span>{{ linkTitles.systemTest }}</span></a
          >
        </li>
      </ng-container>

      <li class="border-bottom">
        <a
          routerLink="/logout"
          routerLinkActive="active"
          [title]="linkTitles.logout"
          [ngbTooltip]="linkTitles.logout"
          [disableTooltip]="(sideNavService.navCollapsed | async) === false"
          placement="right"
          ><i class="fas fa-sign-out-alt"></i><span>{{ linkTitles.logout }}</span></a
        >
      </li>
      <li class="info-only fw-bold">{{ authService.user.firstName }} {{ authService.user.lastName }}</li>
      <li class="info-only">{{ authService.fullFormTimezone }}</li>
    </ul>

    <ul class="list-unstyled secondary-nav" *ngIf="showSecondaryNav">
      <ng-container *ngFor="let navItem of secondaryNav">
        <li *ngIf="isEntitled(navItem)">
          <a
            *ngIf="!navItem.external"
            [routerLink]="[navItem.routerLink]"
            (click)="updateHeaderText(navItem)"
            routerLinkActive="active"
            [title]="navItem.displayText"
            [ngbTooltip]="navItem.displayText"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            ><span>{{ navItem.displayText }}</span></a
          >
          <a
            *ngIf="navItem.external"
            [href]="navItem.routerLink"
            target="_blank"
            [title]="navItem.displayText"
            [ngbTooltip]="navItem.displayText"
            [disableTooltip]="(sideNavService.navCollapsed | async) === false"
            placement="right"
            [ngbTooltip]="navItem.displayText"
            ><span>{{ navItem.displayText }}</span></a
          >
        </li>
      </ng-container>
    </ul>
  </nav>
  <ng-template #editProfile let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update Profile</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <th-edit-my-profile></th-edit-my-profile>
    </div>
  </ng-template>

  <ng-template #userFeedback let-modal>
    <div class="modal-body">
      <th-feedback></th-feedback>
    </div>
  </ng-template>
</div>
